import { Symptom } from "../models/models";

export function averageStar(symptom: Symptom): number {
  return (symptom.throatRating + symptom.noseRating + symptom.headRating + symptom.bodyRating) / 4;
}

export function averageStarOfMax(symptom: Symptom, max: number): number {
  return (averageStar(symptom) / 5) * max;
}
